/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



(function () {
    // var variant = JSON.parse(document.getElementById('current-variant-obj').dataset.variant);
    var btnInquire = document.getElementById('btn-inquire');
    // var productId = document.getElementById('product-id').innerText;
    var productTitle = document.querySelector('.product-title').innerText;
    var userName = document.getElementById('user-name');
    var userEmail = document.getElementById('user-email');
    var url = 'https://calendly.com/michael-gabriels-shop/virtual-appointment';

    document.addEventListener('variant:changed', function (event) {
        variant = event.detail.variant;
        productId = variant.id;
        productTitle = variant.name;
    });


    function createCalendyLink(id, name) {
        var shape = document.querySelector('.product-shapes--link.active') ? document.querySelector('.product-shapes--link.active').getAttribute('data-tooltip') : '';
        var color = variant.options[0] //color option here
        var size = variant.options[1] //size option here
        var stoneSize = document.querySelector('[name="properties[Diamond Carat]"]').value;
        console.log({color, size, stoneSize})
        name = name.replace(/\s/g, '%20');
        var queryStr = 'a1=' + name + '&a3=' + 'Shape%20' + shape + '%2C%0A' +
            'Finger%20Size%20' + size + '%2C%0A' + 'Color%20' + color + '%2C%0A' +
            'Stone%20Size%20' + stoneSize +'%2C%0A' + 'Product%20ID%20' + id;
        if (userName) {
            var customer = userName.innerText.replace(/\s/g, '%20');
            var email = userEmail.innerText;
            url = url + '?name=' + customer + '&email=' + email + '&' + queryStr;
        } else {
            url = url + '?' + queryStr;
        }
    }

    function createTypeFormHiddenFields(id, name) {
        var shape = document.querySelector('.product-shapes--link.active') ? document.querySelector('.product-shapes--link.active').getAttribute('data-tooltip') : '';
        var color = variant.options[0] //color option here
        var size = variant.options[1] //size option here
        var stoneSize = document.querySelector('[name="properties[Diamond Carat]"]').value;
        var productData = 'product=' + name + ',' +
            'shape=' + shape + ',' +
            'size=' + size + ',' +
            'color=' + color + ',' +
            'stone=' + stoneSize;

        var form = document.getElementById('product-type-form')
        form.dataset.tfHidden = productData;
    }

    if (btnInquire) {
        btnInquire.addEventListener('click', function (event) {
            createTypeFormHiddenFields(productId, productTitle);
            var script = document.createElement('script');
            script.src = "//embed.typeform.com/next/embed.js";
            document.body.appendChild(script);

            event.preventDefault();
            createCalendyLink(productId, productTitle);
            setTimeout(function () {
                Calendly.showPopupWidget(url);
            }, 500);
        });
    }

    var selectButtons = document.querySelectorAll('.change-select');

    if (selectButtons) {
        selectButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                console.log(this.dataset.value);
                document.getElementById('size-select').value = this.dataset.value;
            });
        });
    }

    var shapesBlock = document.querySelector('.product-shapes');

    if (shapesBlock) {
        var shapes = new Promise(function(resolve, reject){
            var links = document.querySelectorAll('.product-shapes--link');
            
            var path = window.location.pathname;
            
            links.forEach(function (link) {
                if (link.getAttribute('href') == path) {
                    link.classList.add('active');
                    var gemShape = document.querySelector('.product-shapes--link.active').getAttribute('data-tooltip');
                    document.querySelector('.shape-title').textContent = gemShape;
                }
            })
            resolve();
        });
        shapes.then(function(){
            var gemShape = document.querySelector('.product-shapes--link.active').getAttribute('data-tooltip');
            var shapeInput = document.getElementById('shape-input');
            shapeInput.value = gemShape;
            
        })
    }

    document.addEventListener('DOMContentLoaded', function() {
        // Check if 'collections' is in the URL
        if (location.href.includes('collections')) {
          let lastUrl = location.href;
      
          // Function to reload the page if the URL has changed
          function reloadPageOnUrlChange() {
            const currentUrl = location.href;
            if (lastUrl !== currentUrl) {
              lastUrl = currentUrl;
              location.reload(); // Reload the page
            }
          }
      
          // Listen for changes in the URL using the popstate event (triggered on back/forward navigation)
          window.addEventListener('popstate', reloadPageOnUrlChange);
      
          // Monitor URL changes by observing the history API (for when filters update the query string)
          const originalPushState = history.pushState;
          history.pushState = function(...args) {
            originalPushState.apply(history, args);
            reloadPageOnUrlChange(); // Trigger page reload when URL changes
          };
      
          // Also observe the replaceState method (if filters use this to modify the URL)
          const originalReplaceState = history.replaceState;
          history.replaceState = function(...args) {
            originalReplaceState.apply(history, args);
            reloadPageOnUrlChange(); // Trigger page reload when URL changes
          };
        }
      });

      document.addEventListener('DOMContentLoaded', function () {
        const toolbar = document.querySelector('.collection-toolbar');
        if (!toolbar) return;
      
        const toolbarOffset = toolbar.offsetTop;
      
        function handleScroll() {     
            if (window.scrollY >= toolbarOffset - 100) {
              toolbar.classList.add('toolbar-fixed');
            } else {
              toolbar.classList.remove('toolbar-fixed');
            }
        }
      
        // Run immediately and on events
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleScroll);
      });
      
      

    
      
})();

document.addEventListener('DOMContentLoaded', () => {
    // Find all collection descriptions on the page
    const descriptions = document.querySelectorAll('.shopify-section--rich-text .metafield-rich_text_field');
  
    descriptions.forEach(desc => {
      // Skip if content is short (doesn't need truncation)
      if (desc.textContent.trim().length < 150) return;
  
      // Create the Read more button
      const btn = document.createElement('span');
      btn.className = 'button read-more-btn';
      btn.textContent = 'Read more';
  
      // Insert button right after the description
      desc.insertAdjacentElement('afterend', btn);
  
      // Add click listener to toggle expansion
      btn.addEventListener('click', () => {
        desc.classList.toggle('expanded');
        btn.textContent = desc.classList.contains('expanded') ? 'Read less' : 'Read more';
      });
    });
  });
  